// extracted by mini-css-extract-plugin
export default {"header":"zDI2ePVWgp0HXVX4RgqN","text":"xSgIvtIjXJSV5HSLjX88","buttons":"DLtfTCpm_m15Io4BPORV","placeHolderShimmer":"KJ6g2hdDgMr2mT4LcUI7"};